import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import {connect} from 'react-redux'
import { Toast } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import { validateTel, validateAuthcode } from '../../utils/validate';
import AuthCode from '../../components/common/AuthCode';

import '../../assets/scss/Wallet/bindCard.scss';

class BindCard extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      cardId: '',
      mobile: '',
      authCode: '',
      isSend: false, //是否可以发送验证码
      hasSend: false, //是否以及发送了验证码
      bankName: '',
      supportBank: false, //是否支持该银行
      orderNo: '', //流水号
      regNum: /[^0-9]/g, //数字正则
    }
  }

  componentDidMount() {
    if (window.sessionStorage.getItem('bankId')) {
      this.setState({
        cardId: window.sessionStorage.getItem('bankId')
      }, () => {
        this.handelBlur();
      })
    } else {
      window.sessionStorage.removeItem('bankId');
    }
    this.setState({
      name: this.props.userInfo.name
    })
  }

  onHandlePhone = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    this.sendAuthCode();
  }

  sendAuthCode = () => {
    Toast.loading('发送中，请稍后...', 0.5, async () => {
      const path = `/spread/web/bank/sendAuthCode/${this.state.cardId}/${this.state.mobile}`;
      const res = await Http.get(path);
      if (res.code === 0) {
        Toast.hide();
        this.setState({
          isSend: true,
          orderNo: res.data.orderNo
        })
      } else {
        Toast.fail(res.msg, 2);
      }
    });
  }

  onSuccessSend = () => {
    this.setState({
      hasSend: true,
      isSend: false
    });
  }

  handelInput = (key, event) => {
    this.setState({
      [key]: event.target.value
    })
  }

  //银行卡号失焦
  handelBlur = async () => {
    if (!this.state.cardId) return;
    if (this.state.cardId.length < 6) {
      Toast.fail('请输入正确的银行卡信息！', 2);
      return;
    }
    const path = `/spread/web/bank/cardBin/${this.state.cardId}`;
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        bankName: res.data.bankName,
        supportBank: true
      })
    } else {
      Toast.fail(res.msg, 2);
      this.setState({
        bankName: '',
        supportBank: false
      })
    }
  }
 
  confirm = () => {
    if (!validateTel(this.state.mobile)) {
      Toast.info('请输入正确的手机号码！', 2);
      return;
    }
    if (!this.state.hasSend) {
      Toast.info('请先获取验证码！', 2);
      return;
    }
    if (!validateAuthcode(this.state.authCode)) {
      Toast.info('请输入正确的验证码！', 2);
      return;
    }
    this.addBank();
  }

  addBank = async () => {
    const path = '/spread/web/bank/bind';
    const postData = {
      authCode: this.state.authCode,
      bankMobile: this.state.mobile,
      bankNo: this.state.cardId,
      orderNo: this.state.orderNo
    }
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      this.props.history.goBack();
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  keyupEvent = (key, event) => {
    this.setState({
      [key]: event.target.value.replace(this.state.regNum, '')
    })
  }

  goSupportBank = () => {
    setTimeout(() => {
      if (this.state.cardId && this.state.cardId.length >=6 && this.state.supportBank) {
        window.sessionStorage.setItem('bankId', this.state.cardId);
      }
      this.props.history.push('/supportBank');
    }, 500);
  }

  render () {
    const isCanConfirm = Boolean(this.state.mobile && this.state.supportBank && this.state.authCode);
    return (
      <div>
        <Helmet><title>添加银行卡</title></Helmet>
        <div className='bindCard'>
          <ul className='info'>
            <li>
              <div>姓名</div>
              <div className='info-text'>{this.state.name}</div>
            </li>
            <li>
              <div>银行卡号</div>
              <div className='info-bank'>
                <input type="tel"
                  maxLength="22"
                  placeholder="请输入银行卡号"
                  name="cardId"
                  value={this.state.cardId}
                  onChange={this.handelInput.bind(this, 'cardId')}
                  onKeyUp={this.keyupEvent.bind(this, 'cardId')}
                  onBlur={this.handelBlur} />
                <span onClick={this.goSupportBank}>支持银行</span>
              </div>
            </li>
            <li>
              <div>银行名称</div>
              <div className='info-text'>{this.state.cardId && this.state.bankName}</div>
            </li>
            <li>
              <div>预留手机号</div>
              <input type="tel"
                maxLength="11"
                placeholder="请输入预留手机号"
                name="mobile"
                value={this.state.mobile}
                onChange={this.handelInput.bind(this, 'mobile')}
                onKeyUp={this.keyupEvent.bind(this, 'mobile')} />
            </li>
            <li>
              <div>验证码</div>
              <div className='info-auth'>
                <input type="tel"
                  maxLength="6"
                  placeholder="请输入验证码"
                  name="authCode"
                  value={this.state.authCode}
                  onChange={this.handelInput.bind(this, 'authCode')}
                  onKeyUp={this.keyupEvent.bind(this, 'authCode')} />
                <AuthCode isSend={this.state.isSend} isHighColor={Boolean(this.state.mobile && this.state.supportBank)} onHandlePhone={this.onHandlePhone} onSuccessSend={this.onSuccessSend}></AuthCode>
              </div>
            </li>
          </ul>
          <div className={`confirm ${!isCanConfirm && 'high'}`} onClick={isCanConfirm ? this.confirm : () => {return false}}>确定</div>
        </div>
      </div>
    )
  }
}

BindCard.propTypes = {
  userInfo: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userInfo
  }
}

export default connect(mapStateToProps)(BindCard);